import type { Preset, PresetOptionType } from '@modules/global-style';
import type { ProcessStepPreset } from './types';
import type { TCategorySidebar, TElementSidebarEditor } from '../types';

export class State {
  public fontManager: [];
  public pages: any[];
  public presets: Preset[];
  public isLoadingPreset: boolean;
  public presetModal: boolean;
  public linkedPresetId: any;
  public oldLinkedPresetId: any;
  public previewPreset: boolean;
  public currentPreset: Preset;
  public currentPresetInPage: Preset;
  public currentPresetOptions: any;
  public presetModalNotify: string;
  public prevPreset: ProcessStepPreset;
  public nextPreset: ProcessStepPreset;
  public currentPresetOptionType: PresetOptionType;
  public variablesColorStyle: any;
  public variablesColorStylePresetInPage: any;
  public styleIdTargetGlobalStyle: any;
  public pageSavedGlobalStyle: boolean;
  public isCallingApi: boolean;
  public isOpenSetting: boolean;
  public isAppliedGsForPage: boolean;
  public isPublishPreset: boolean;
  public sideBarElement: null | any;
  public elementKeySettingActive: string | null;
  public tabs: {
    key: 'elements' | 'global_style';
    label: string;
    isActive: boolean;
  }[];
  public viewTargetPreset: any;
  public componentTargetGlobalStyle: any;
  public isLoadingSnippet: boolean;
  public snippetCategories: TCategorySidebar[];
  public newSnippets: { [x: string]: TElementSidebarEditor[] };
  public snippetDeleted: { [x: string | number]: true };
  constructor() {
    this.presetModal = false;
    this.presetModalNotify = '';
    this.currentPresetOptions = [];
    this.presets = [];
    this.snippetCategories = [];
    this.snippetDeleted = {};
    this.isLoadingPreset = true;
    this.pages = [];
    this.newSnippets = {};
    this.isLoadingSnippet = false;
    this.nextPreset = {} as ProcessStepPreset;
    this.prevPreset = {} as ProcessStepPreset;
    this.previewPreset = false;
    // this.obGlobalStyle = null;
    this.linkedPresetId = null;
    this.oldLinkedPresetId = null;
    this.isAppliedGsForPage = false;
    this.sideBarElement = null;
    this.tabs = [
      {
        key: 'elements',
        label: 'Elements',
        isActive: true,
      },
      {
        key: 'global_style',
        label: 'Global Style',
        isActive: false,
      },
    ];
    this.viewTargetPreset = '';
    this.componentTargetGlobalStyle = '';
    this.variablesColorStyle = '';
    this.variablesColorStylePresetInPage = '';
    this.styleIdTargetGlobalStyle = '';
    this.pageSavedGlobalStyle = false;
    this.isCallingApi = false;
    this.isOpenSetting = false;
    this.isPublishPreset = false;
    this.elementKeySettingActive = null;
  }
}

const state = new State();

export default state;
